module.exports = __webpack_public_path__ + "img/correlated-xtend-traffic-popup.cb57cf0e.png";